import styled from 'styled-components';
import { themeGet, getMediaQuery, getTextColor } from '@magalu/stereo-ui-styles';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Text from '@magalu/stereo-ui/atoms/Text';
export const ModalDetails = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 20px 16px;
  z-index: ${themeGet('zIndices.4')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: 500px) {
    display: none;
  }
`;
export const DescriptionBlock = styled.div`
  color: white;
  text-align: start;
  width: 100%;
`;
export const ModalDetailsBody = styled.div`
  margin: auto;
  ${getMediaQuery('medium')} {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 720px;
    gap: 30px;
  }
`;
export const ModalDetailsHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: end;
  width: 100%;
`;
export const CloseButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const SeeMore = styled(Box).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
export const CaroulselBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: calc(100% - 80px);
  margin: auto;
  ${getMediaQuery('medium')} {
    max-width: 280px;
  }
`;
export const ReviewContainer = styled(Box)``;
export const Header = styled(Flex)`
  padding: 0 0 ${props => themeGet('space.2')(props)}px;
  ${getMediaQuery('large')} {
    padding: 0 0 ${props => themeGet('space.3')(props)}px;
  }
`;
export const ReviewerName = styled(Text).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => getTextColor('white')(props)};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  padding: ${props => themeGet('space.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;
export const ReviewWrapper = styled.span`
  width: 80px;
`;
export const RotateButtonBlock = styled(Flex)`
  width: 100%;
  height: 32px;
  margin: 18px 0 0;
`;